// extracted by mini-css-extract-plugin
export var wrapper = "pagination-module--wrapper--3GJfU";
export var pageNumber = "pagination-module--page-number--1kZqZ";
export var button = "pagination-module--button--26KzM";
export var buttonInactive = "pagination-module--button-inactive--3-9UL";
export var pageNumberActive = "pagination-module--page-number-active--_oNts";
export var pageNumberMenu = "pagination-module--page-number-menu--3APQZ";
export var closeButton = "pagination-module--close-button--357UR";